import React from 'react';
import PropTypes from 'prop-types';

import './FiltersExposedTitle.scss';

const FiltersExposedTitle = ({ title, subtitle, renderSubtitleTooltip }) => (
  <div className="filters-exposed-title">
    <div className="filters-exposed-title__title">{title} </div>
    <p className="filters-exposed-title__subtitle">
      {subtitle} {renderSubtitleTooltip()}
    </p>
  </div>
);

FiltersExposedTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  renderSubtitleTooltip: PropTypes.func
};

FiltersExposedTitle.defaultProps = {
  subtitle: '',
  renderSubtitleTooltip: () => {}
};

export default FiltersExposedTitle;
